export const GroupWork = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="MuiSvgIcon-root"
  >
    <path
      d="M12.0654 2.53857C6.54543 2.53857 2.06543 7.01857 2.06543 12.5386C2.06543 18.0586 6.54543 22.5386 12.0654 22.5386C17.5854 22.5386 22.0654 18.0586 22.0654 12.5386C22.0654 7.01857 17.5854 2.53857 12.0654 2.53857ZM12.0654 20.5386C7.65543 20.5386 4.06543 16.9486 4.06543 12.5386C4.06543 8.12857 7.65543 4.53857 12.0654 4.53857C16.4754 4.53857 20.0654 8.12857 20.0654 12.5386C20.0654 16.9486 16.4754 20.5386 12.0654 20.5386Z"
      fill="#CBDAFF"
    />
    <path
      d="M8.06543 16.5386C9.17 16.5386 10.0654 15.6431 10.0654 14.5386C10.0654 13.434 9.17 12.5386 8.06543 12.5386C6.96086 12.5386 6.06543 13.434 6.06543 14.5386C6.06543 15.6431 6.96086 16.5386 8.06543 16.5386Z"
      fill="#FF8A1E"
    />
    <path
      d="M16.0654 16.5386C17.17 16.5386 18.0654 15.6431 18.0654 14.5386C18.0654 13.434 17.17 12.5386 16.0654 12.5386C14.9609 12.5386 14.0654 13.434 14.0654 14.5386C14.0654 15.6431 14.9609 16.5386 16.0654 16.5386Z"
      fill="#64C668"
    />
    <path
      d="M12.0654 10.5386C13.17 10.5386 14.0654 9.64314 14.0654 8.53857C14.0654 7.434 13.17 6.53857 12.0654 6.53857C10.9609 6.53857 10.0654 7.434 10.0654 8.53857C10.0654 9.64314 10.9609 10.5386 12.0654 10.5386Z"
      fill="#376FFF"
    />
  </svg>
);
